(function () {
  function log(...args) {
    console.log("[PROMO-COPY]", ...args);
  }

  async function copyText(text) {
    if (!text) return false;

    // Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // Fallback (execCommand)
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();

    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".halo-newsletter-popup.style-2 .button-code--copy");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const wrap = btn.closest(".code__input");
    const input = wrap ? wrap.querySelector(".field__input") : null;
    const text = input ? input.value.trim() : "";

    log("click copy", { text });

    try {
      const ok = await copyText(text);

      // feedback no tooltip (se existir)
      const tip = btn.querySelector(".tooltip");
      const success = tip?.getAttribute("data-success_message") || "Copiado";
      const original = tip?.textContent;

      if (tip) {
        tip.textContent = ok ? success : "Falhou";
        tip.style.display = "block";
        tip.style.opacity = "1";
        tip.style.visibility = "visible";

        setTimeout(() => {
          if (original != null) tip.textContent = original;
          tip.style.opacity = "";
          tip.style.visibility = "";
          // se você tinha escondido no CSS, ele volta ao normal
        }, 900);
      }

      // opcional: feedback visual no input
      if (ok && input) input.classList.add("is-copied");
      setTimeout(() => input && input.classList.remove("is-copied"), 600);

      log("copy result:", ok);
    } catch (err) {
      console.error("[PROMO-COPY] error:", err);
    }
  });
})();
